module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VGGyumaoM-d404614d876c05ff1efbca7ea5a7d71a.png";